import React, { Component } from 'react';
import Immutable from "immutable";

class TrendingPic extends Component {
	 constructor(props){
		  super(props);
		  this.state = {
		  	list :[],
		  }
		 this.getTrend = this.getTrend.bind(this);
	}

	getTrend(){
		let { theme } = this.props;
		let that = this;
		//theme = 'she.com';
		// fetch('/asset/'+theme+'/trendpic.json?t='+(new Date()).getTime(),{
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/asset/she.com/trendpic.json?t='+(new Date()).getTime(),{
			method:"GET",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
			.then(function(response){
				that.setState({ list:response });
				var d1 = new Date();
				var d2 = Date.parse(response['time']);
				var diff = d1 - d2;
				if (Math.floor(diff / 60e3)>60){
					fetch('/wp-json/she-rest-api/rebuildTrendingPic',{
						method:"POST"
					})
				}


			}).catch(function(error){
				console.error(error);
				fetch('/wp-json/she-rest-api/rebuildTrendingPic', {method: "POST"});
			});
	}

	componentDidMount(){
		this.getTrend();
	}

	render(){
		const {list} = this.state;
		const {theme,page,enable} = this.props;
		// const { tags } = this.state;

		if (enable == false){
			return ''
		}

		let list1 = [];
		let list2 = [];
		let list3 = [];
		let list4 = [];
		function shuffle(arr) {
			var i,
				j,
				temp;
			for (i = arr.length - 1; i > 0; i--) {
				j = Math.floor(Math.random() * (i + 1));
				temp = arr[i];
				arr[i] = arr[j];
				arr[j] = temp;
			}
			return arr;
		};
		if (list !=undefined){
			if (list[page] !=undefined){
				if (page ==0){
					let thisitem = list[page].shift();
					let thisitem1 = list[page].shift();
					let thisitem2 = list[page].shift();

					list1.push(<div className={thisitem.custom? 'image0 custom-pic':'image0'} data-title={thisitem.title}><a href={thisitem.url} data-title={thisitem.title}><img src={thisitem.src}/></a></div>)
					list1.push(<div className={thisitem1.custom? 'image1 custom-pic':'image1'} data-title={thisitem1.title}><a href={thisitem1.url} data-title={thisitem1.title}><img src={thisitem1.src}/></a></div>)
					list1.push(<div className={thisitem2.custom? 'image2 custom-pic':'image2'} data-title={thisitem2.title}><a href={thisitem2.url} data-title={thisitem2.title}><img src={thisitem2.src}/></a></div>)
					list[0] = shuffle(list[0]);
					list[0].push(thisitem);
					list[0].push(thisitem1);
					list[0].push(thisitem2);
				}else{
					if (list[page].length >=6) {
						for (let i = 0; i <= 2; i++) {
							//記得在JSX中使用JS變數要用花括號包著
							if (list[page][0] !== undefined && list[page][0].used !== true) {
								let thisitem = list[page].shift();
								list1.push(<div className={thisitem.custom ? 'image' + i + ' custom-pic' : 'image' + i}
												data-title={thisitem.title}><a href={thisitem.url}
																			   data-title={thisitem.title}><img
									src={thisitem.src}/></a></div>)
								thisitem.used = true;
								list[page].push(thisitem);
							} else if (i !== 0 && list1[0] !== undefined) {
								list1.push(<div className={'image' + i}><img
									src="https://she.com/asset/she.com/img/default-300x400.jpg" className="tp-hide"/>
								</div>)
							}
						}
					}
				}
				if (list[page].length >=6) {
					for (let i = 0; i <= 2; i++) {
						//記得在JSX中使用JS變數要用花括號包著
						if (list[page][0] !== undefined && list[page][0].used !== true) {
							let thisitem = list[page].shift();
							list2.push(<div className={thisitem.custom ? 'image' + i + ' custom-pic' : 'image' + i}
											data-title={thisitem.title}><a href={thisitem.url}><img src={thisitem.src}/></a>
							</div>)
							thisitem.used = true;
							list[page].push(thisitem);
						} else if (i !== 0 && list2[0] !== undefined) {
							list2.push(<div className={'image' + i}><img
								src="https://she.com/asset/she.com/img/default-300x400.jpg" className="tp-hide"/></div>)
						}

					}
				}
				if (list[page].length ==15){
					for(let i=0;i<=2;i++){
						//記得在JSX中使用JS變數要用花括號包著
						if (list[page][0] !== undefined && list[page][0].used !== true){
							let thisitem = list[page].shift();
							list3.push(<div className={thisitem.custom? 'image'+i+' custom-pic':'image'+i} data-title={thisitem.title}><a href={thisitem.url} data-title={thisitem.title}><img src={thisitem.src}/></a></div>)
							thisitem.used = true;
							list[page].push(thisitem);
						}else if (i !==0 && list3[0]!==undefined){
							list3.push(<div className={'image'+i} ><img src="https://she.com/asset/she.com/img/default-300x400.jpg" className="tp-hide" /></div>)
						}

					}
					for(let i=0;i<=5;i++){
						//記得在JSX中使用JS變數要用花括號包著
						if (list[page][0] !== undefined && list[page][0].used !== true){
							let thisitem = list[page].shift();
							list4.push(<div className={thisitem.custom? 'image'+i+' custom-pic':'image'+i} data-title={thisitem.title}><a href={thisitem.url}><img src={thisitem.src} data-title={thisitem.title}/></a></div>)
							thisitem.used = true;
							list[page].push(thisitem);
						}else if (i !==0 && list4[0]!==undefined){
							list4.push(<div className={'image'+i} ><img src="https://she.com/asset/she.com/img/default-300x400.jpg" className="tp-hide" /></div>)
						}

					}
					for (let i=0;i<=14;i++){
						//記得在JSX中使用JS變數要用花括號包著
						if (list[page][i] !== undefined ){
							list[page][i].used = false;
						}

					}
				}

			}
		}
		console.log(list1.length);

		if (list[page] !=undefined && list1.length !=0){
			return (
				<div className="tp-whole">
					<div className="trending-pic">
						<p className="tp-title">TRENDING PIC #</p>
						<div className="trendblock-1">
							{list1}
						</div>
						<div className="trendblock-2">
							{list2}
						</div>
						<div className="trendblock-3">
							{list3}
						</div>
						<div className="trendblock-4">
							{list4}
						</div>
					</div>
				</div>
			)
		}else{
			return''
		}


	}
}

export default TrendingPic



// WEBPACK FOOTER //
// ./src/TrendingPic.js